import { render, staticRenderFns } from "./NewAlternatives.vue?vue&type=template&id=fc57a54c&"
import script from "./NewAlternatives.vue?vue&type=script&lang=js&"
export * from "./NewAlternatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports